<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title
          justify-center
          class="justify-center headline purple--text title font-weight-bold"
        >{{$t('Registration')}}</v-card-title>
        <v-form ref="form" v-model="valid">
          <v-card-text>
            <v-text-field
              box
              color="purple"
              v-validate="'required|max:10'"
              v-model="firstName"
              :counter="10"
              :error-messages="errors.collect('firstName')"
              :label="$t('First Name')"
              name="firstName"
              data-vv-name="firstName"
              :placeholder="$t(placeholder.firstName)"
              required
            ></v-text-field>
            <v-text-field
              box
              color="purple"
              v-validate="'required'"
              name="lastName"
              v-model="lastName"
              :error-messages="errors.collect('lastName')"
              :label="$t('Last Name')"
              data-vv-name="lastName"
              :placeholder="$t(placeholder.lastName)"
              required
            ></v-text-field>
            <v-text-field
              box
              color="purple"
              v-validate="'required|email'"
              name="email"
              v-model="email"
              :error-messages="errors.collect('email')"
              :label="$t('E-mail')"
              data-vv-name="email"
              :placeholder="$t(placeholder.email)"
              required
            ></v-text-field>
            <v-text-field
              box
              class="custom-append"
              color="purple"
              ref="password"
              name="password"
              :label="$t('Password')"
              data-vv-name="password"
              data-vv-delay="300"
              min="8"
              v-validate="'required|min:8'"
              v-model="password"
              :error-messages="errors.collect('password')"
              :type="isPasswordVisible ? 'text' : 'password'"
              :placeholder="$t(placeholder.password)"
            >
              <template slot="append">
                <div @click="changeVal('isPasswordVisible')">
                  <span v-if="!isPasswordVisible">{{$t('Show')}}</span>
                  <span v-else>{{$t('Hide')}}</span>
                </div>
              </template>
            </v-text-field>
            <v-text-field
              box
              class="custom-append"
              color="purple"
              :label="$t('CONFIRM PASSWORD')"
              data-vv-name="password_confirmation"
              data-vv-delay="300"
              target="password"
              v-validate="'required|confirmed:password'"
              v-model="password_confirmation"
              :error-messages="errors.collect('password_confirmation')"
              :type="isPasswordVisible2 ? 'text' : 'password'"
              :placeholder="$t(placeholder.confirmPassword)"
            >
              <template slot="append">
                <div @click="changeVal('isPasswordVisible2')">
                  <span v-if="!isPasswordVisible2">{{$t('Show')}}</span>
                  <span v-else>{{$t('Hide')}}</span>
                </div>
              </template>
            </v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-layout align-center justify-center column>
              <v-flex>
                <v-btn dark color="purple" @click="submit">{{$t('REGISTER')}}</v-btn>
              </v-flex>
              <v-flex>
                <!-- https://codesandbox.io/s/o14vnjq66 -->
                <v-btn outline color="purple" @click="auth0">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="3059.924 1979 16.08 16" id="google_logo">
                    <path
                      d="M3069.04,2012.4v3.2h4.549a4.82,4.82,0,1,1-4.549-6.4,4.768,4.768,0,0,1,3.124,1.158l2.113-2.413a7.981,7.981,0,1,0,2.8,6.054v-1.6Z"
                      transform="translate(-1.076 -27)"
                    ></path>
                  </svg>{{$t('SIGN IN WITH GOOGLE')}}
                </v-btn>
              </v-flex>
              <v-flex class="text-xs-center font-weight-bold">{{$t('Back to')}}
                <router-link to="/" class="purple--text">{{$t('login page')}}</router-link>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialog" max-width="350">
      <v-card>
        <v-card-title class="text-xs-center">{{errorMsg}}</v-card-title>
        <v-card-actions v-if="successRegister">
          <v-btn dark color="purple" @click="successRegistered">{{errorBtn}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <ShowDialog v-model="shown" msg="dawdaw"></ShowDialog> -->
  </v-layout>
</template>
<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
// import ShowDialog from "@/components/ShowDialog";
// import { ErrorBag } from "vee-validate";
// import { Validator } from "vee-validate";
import axios from "axios";

Vue.use(VeeValidate);

export default {
  name: "Registration",
  // components: {
  //     ShowDialog
  // },
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    placeholder: {
      firstName: Vue.i18n.translate('Enter your firstname'),
      lastName: Vue.i18n.translate('Enter your lastname'),
      email: Vue.i18n.translate('Enter your email'),
      password: Vue.i18n.translate('Enter your password'),
      confirmPassword: Vue.i18n.translate('Enter confirm password'),
    },
    // shown: false,
    dialog: true,
    valid: true,
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    password_confirmation: "",
    isPasswordVisible: false,
    isPasswordVisible2: false,
    successRegister: false,
    errorDialog: false,
    errorMsg: "IDK why do u see this window",
    errorBtn: "Ok",
    dictionary: {
      custom: {
        firstName: {
          required: () => Vue.i18n.translate("First Name can not be empty"),
          max: Vue.i18n.translate('The first name field may not be greater than {amount} characters', {amount: 10})
        },
        lastName: {
          required: () => Vue.i18n.translate("Last Name can not be empty")
        },
        email: {
          required: () => Vue.i18n.translate("Email can not be empty"),
          email: Vue.i18n.translate("Invalid email"),
          unique: Vue.i18n.translate("This mail is already used")
        },
        password: {
          required: () => Vue.i18n.translate("Password can not be empty"),
          min: Vue.i18n.translate("The password field may not be lesser than {amount} characters", {amount: 8})
        },
        password_confirmation: {
          required: () => Vue.i18n.translate("Password confirmation can not be empty"),
          confirmed: Vue.i18n.translate("The password confirmation does not match")
        }
      }
    }
  }),
  mounted() {
    this.$validator.localize("uk", this.dictionary);
  },
  methods: {
    submit() {
      // https://codesandbox.io/s/y3504yr0l1?from-embed
      // https://baianat.github.io/vee-validate/concepts/backend.html
      // console.log(this.$validator);
      this.$validator
        .validateAll()
        .then(result => {
          if (result) {
            axios
              .post(this.$hostname +"/client/registration", {
                firstname: this.firstName,
                lastname: this.lastName,
                email: this.email,
                password: this.password
              })
              .then(response => {
                console.log(response);
                if(response.status === 200){
                  this.successRegister = true
                  this.errorDialog = true
                  this.errorBtn = this.$t('go to login')
                  this.errorMsg = this.$t("Check you're email to confirm registration")
                }
                // if (response.data.detail === 101) {
                //   let error = response.data.errors;
                //   if (error.password) {
                //     (this.errorDialog = true),
                //       (this.errorMsg =
                //         "password requires at least 8 characters");
                //   } else if (error.mail) {
                //     (this.errorDialog = true),
                //       (this.errorMsg = "This email has been already taken");
                //   } else if (error.email_validation) {
                //     (this.errorDialog = true),
                //       (this.errorMsg = "Invalid email");
                //   } else {
                //     alert("oops");
                //   }
                // } else {
                //   this.$router.push("/");
                // }
                //  "email":"dmitrosichenko@ukr.net", "dmitrosichenko@gmail.com". "don.petruchio.1999@gmail.com"
                //  "password":"somepass", 12345678
              })
              .catch(error => {
                this.errorDialog = true
                this.errorMsg = `${this.$t(this.$store.getters.errorsList[error.response.data.message])}`
              });
          }
          console.log(result);
        })
        .catch(error => console.log(error));
    },
    // open(){
    //   this.shown = true
    // },
    changeVal(value) {
      this[value] = !this[value];
    },
    successRegistered (){
      this.$router.push('/')
    },
    auth0() {
      Vue.googleAuth().signIn(
        authorizationCode => {
          axios
            .post(this.$hostname + "/client/google/login", {
              code: authorizationCode,
              redirect_uri: this.$googleLink
            })
            .then(response => {
              localStorage.setItem("token", response.data.data.token);
              this.$router.push("/profile");
            })
            .catch(error => {
              this.errorDialog = true
              this.errorMsg = `${this.$t(this.$store.getters.errorsList[error.response.data.message])}`
            });
        },
        error => {
          this.errorDialog = true
          this.errorMsg = `${this.$t(this.$store.getters.errorsList[error.response.data.message])}`
        }
      );
    },
  }
};
</script>
<style scoped lang="scss">
.error-dialog{
  .v-card__actions{
    padding: 0
  }
}
</style>